//Third party packages
import { Row, Col, Card } from 'react-bootstrap';

import Skeleton from 'src/Admin/components/common/skeleton';

export default () => (
  <Row className="mt-2">
    <Col sm={12}>
      <Card className="p-3">
        <Skeleton count={1} height={100} />
      </Card>
    </Col>
  </Row>
);
